import { gql } from '@apollo/client';

export const ADMIN_USERS_QUERY = gql`
  query AdminUsers(
    $after: String
    $first: Int
    $orderBy: String
    $order: String
  ) {
    adminUsers(after: $after, first: $first, orderBy: $orderBy, order: $order) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        email
        firstName
        lastName
        phone
        productUpdateEmail
        lastSeenAt
        createdAt
        magicLoginLink
        venues {
          id
          name
        }
        organization {
          id
          name
        }
      }
    }
  }
`;
